/** Pixels of the banner intersecting the viewport from y = 0 (for fixed `top` offsets). */
export function getLiveBannerTopInset(rect: DOMRect): number {
  const maxHeight = Math.max(0, rect.height);

  if (maxHeight === 0 || rect.bottom <= 0 || rect.top > 0) {
    return 0;
  }

  const inset = Math.min(rect.bottom, maxHeight);

  return Math.max(0, Math.min(Math.round(inset), Math.round(maxHeight)));
}

export function clampLiveBannerHeightPx(insetPx: number, maxHeightPx: number): number {
  const max = Math.max(0, Math.round(maxHeightPx));

  return Math.max(0, Math.min(Math.round(insetPx), max));
}
